import { HowToReg, LoginOutlined } from '@mui/icons-material';
import { Alert, Box, Button, type SxProps } from '@mui/material';
import type { ReactNode } from 'react';
import { useUrl } from '@/utils/client/route';

export default function LoginPrompt({
  sx,
  children,
}: {
  sx?: SxProps;
  children: string | ReactNode;
}) {
  const { loginUrl, registerUrl } = useUrl();

  return (
    <Box sx={sx}>
      <Alert
        severity="info"
        icon={<HowToReg />}
        action={
          <Button variant="contained" color="info" size="small" target="_blank" href={registerUrl}>
            Registrieren
          </Button>
        }>
        {children}
      </Alert>
      <Alert
        severity="info"
        icon={<LoginOutlined />}
        sx={{ my: (theme) => theme.spacing(2) }}
        action={
          <Button variant="outlined" color="info" size="small" target="_blank" href={loginUrl}>
            Anmelden
          </Button>
        }>
        Du hast bereits einen Account?
      </Alert>
    </Box>
  );
}
